import React from 'react'
import { Container } from 'reactstrap'

const Header = ({ init, end }) => (
  <Container className='d-flex flex-column justify-content-center align-items-center container m-3 mx-auto container container'>
    <h1 className='display-2'>Ofertas</h1>
    <div className='offert-separator' />
    <h1 className='subtitle'>
      Válidas del {init} al {end}
    </h1>
  </Container>
)

export default Header